
import { Textarea } from "@/components/ui/textarea";

interface TextInputProps {
  text: string;
  setText: (text: string) => void;
}

const TextInput = ({ text, setText }: TextInputProps) => {
  const handleTextChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setText(e.target.value);
  };

  return (
    <div className="mb-4">
      <Textarea
        placeholder="Enter text to analyze..."
        value={text}
        onChange={handleTextChange}
        className="min-h-[120px]"
      />
    </div>
  );
};

export default TextInput;
